import React, { Component } from 'react'

import './QbInputDropdown.css'
import { fromEvent } from 'rxjs'
import { pluck, takeWhile } from 'rxjs/operators'

class QbInputDropdown extends Component {

  constructor(props) {
    super(props)
    this.state = {
      showItems: false,
      selectedItem: this.props.dpItems[0]
    }
  }  

  componentWillMount() {
    this.handleClickSubscription$ = DocumentClick$.pipe(
      takeWhile(() => this.buttonNode)
    ).subscribe(evt => {
      const { showItems } = this.state
      if (showItems && !this.buttonNode.contains(evt)) {
        this.setState({ showItems: false })
      }
    })
  }

  toggleShowItems = () => {
    this.setState({ showItems: !this.state.showItems })
  }

  handleSelectItem = (index) => {
    const { onSelectDpItem } = this.props

    this.setState({
      selectedItem: this.props.dpItems[index],
      showItems: false
    }, () => {
      if (onSelectDpItem) {
        onSelectDpItem(this.state.selectedItem)
      }
    })
  }

  render() {
    const { dpItems } = this.props
    const { showItems, selectedItem } = this.state

    return (
      <div className="qb-input-dropdown-container">
        <div ref={node => this.buttonNode = node} className={getDpButtonClass(showItems)} onClick={this.toggleShowItems}>
          <span style={{width: '30px', paddingLeft: '5px'}}>{selectedItem}</span>
          <span style={{width: '13px'}}>▾</span>
        </div>
        <div className={getDpItemsClass(showItems)}>
          {
            dpItems.map((item, i) =>
              <div onClick={() => this.handleSelectItem(i)} key={i} className="qb-input-dropdown-item">
                {item}
              </div>
            )
          }
        </div>
      </div>
    )
  }  
}

export default QbInputDropdown

function getDpItemsClass(showItems) {
  return `qb-input-dropdown-items ${showItems ? 'qb-input-dropdown-items--show' : ''}`
}

function getDpButtonClass(showItems) {
  return `qb-input-dropdown-button ${showItems ? 'qb-input-dropdown-button--border' : ''}`
}

const DocumentClick$ = fromEvent(document, 'click').pipe(  
  pluck('target')
)


// WEBPACK FOOTER //
// ./src/components/shared/QbInput/QbInputDropdown/QbInputDropdown.js